<template>
    <section id="what-we-solve" class="solve">

        <div class="solve__container">

            <div class="solve__header">

                <span class="solve__tag">

                    {{'WHAT WE SOLVE' | i}}

                </span>

                <h2 class="solve__title">

                    {{ 'what_we_solve' | staticTitle }}

                </h2>

                <p class="solve__description pre-line">

                    <vue-marked>{{ 'what_we_solve' | staticContent }}</vue-marked>
                    

                </p>

                <p class="solve__description solve__description--bold">

                    <vue-marked>{{ 'what_we_solve' | staticContentAlt }}</vue-marked>

                </p>

            </div>

            <div class="solve__visual__blocks">

                <article class="solve__visual__block" v-for="(visualBlock, index) in $options.filters.portfolioFetchBy('visual_blocks')" :key="index">

                    <div class="solve__visual__block__content">

                        <span class="solve__visual__block__index">{{ (index + 1) | zeroPad }}</span>
                        <div class="solve__visual__block__line"></div>
                        <h2>{{ visualBlock.title }}</h2>
                        <vue-marked>{{ visualBlock.content }}</vue-marked>

                    </div>

                </article>

            </div>

        </div>

    </section>
</template>

<script>
export default {
    name: 'HomeSolve',
    filters: {
        zeroPad(value) {
            return String(value).padStart(2, '0');
        }
    }
};
</script>

<style lang="scss">
    .solve__visual__blocks {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 24px;
        color: var(--dark);
        margin-top: 40px;
    }

    .solve__visual__block {
        border-radius: 16px;
        background-color: #fff;
        border: 1px solid rgba(0, 0, 0, 0.06);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        transition: box-shadow 0.3s ease, transform 0.3s ease, border-color 0.3s ease;

        &:hover {
            box-shadow: 0 18px 40px rgba(0, 0, 0, 0.1);
            transform: translateY(-8px);
            border-color: rgba(198, 161, 91, 0.45);
        }
    }

    .solve__visual__block__index {
        display: block;
        font-family: "Cormorant Garamond", serif;
        font-size: 15px;
        font-weight: 600;
        letter-spacing: .15em;
        color: var(--primary);
    }

    .solve__visual__block__line {
        width: 36px;
        height: 2px;
        background: var(--primary);
        margin: 14px 0 18px;
        transition: width .4s ease;
    }

    .solve__visual__block:hover .solve__visual__block__line {
        width: 56px;
    }

    .solve__visual__block__content {
        padding: 32px 28px;
        display: flex;
        flex-direction: column;
        flex: 1;

        h2 {
            font-size: 19px;
            font-weight: 700;
            letter-spacing: .04em;
            text-transform: uppercase;
            margin-bottom: 14px;
            color: var(--dark);
            line-height: 1.3;
        }

        p, ul, ol {
            font-size: 15px;
            line-height: 1.7;
            color: rgba(0, 0, 0, 0.65);
            margin: 0;
        }

        ul, ol {
            padding-left: 20px;
        }
    }

    @media (max-width: 992px) {
        .solve__visual__blocks {
            grid-template-columns: repeat(2, 1fr);
        }
    }

    @media (max-width: 560px) {
        .solve__visual__blocks {
            grid-template-columns: 1fr;
        }
    }
</style>